export enum RootActionTypes {
    RESET_STATE = "RESET_STATE"
}

type ResetStateAction = {
    type: RootActionTypes.RESET_STATE
}

export const resetState = (): ResetStateAction => ({
    type: RootActionTypes.RESET_STATE
});

export type RootActions = ResetStateAction;